import { Ref, ref, watch } from 'vue'

import {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import { HandballAttributeId } from '@collector/sportsapi-client-legacy'
import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import { usePositionSelections } from './usePositionSelections'

interface UseThrowPositionDetailsModalForm {
  assistant: Ref<ProbableIncident['assistant_id']>
  goalkeeper: Ref<ProbableIncident['goalkeeper_id']>
  pitchDistance: Ref<PitchDistance | null>
  pitchPosition: Ref<PitchPosition | null>
  goalPosition: Ref<GoalPosition | null>
}

export function useThrowPositionDetailsModalForm(
  linkedIncident: ProbableLinkedIncident,
  removeAttribute: (attribute: HandballAttributeId) => void,
  addAttribute: (attribute: HandballAttributeId) => void,
  distanceAttributeMap: Map<PitchDistance, HandballAttributeId>,
  positionAttributeMap: Map<PitchPosition, HandballAttributeId>,
  goalPositionAttributeMap?: Map<GoalPosition, HandballAttributeId>,
  onWingPositionSelected?: (position: PitchPosition) => void,
): UseThrowPositionDetailsModalForm {
  // state
  const assistant = ref(linkedIncident.incident.assistant_id)
  const goalkeeper = ref(linkedIncident.incident.additional_info?.goalkeeper_id)

  const { pitchDistance, pitchPosition, goalPosition } = usePositionSelections(
    linkedIncident,
    removeAttribute,
    addAttribute,
    distanceAttributeMap,
    positionAttributeMap,
    goalPositionAttributeMap,
  )

  if (onWingPositionSelected) {
    watch(pitchPosition, (position) => {
      if (position?.includes('wing')) {
        onWingPositionSelected?.(position)
      }
    })
  }

  return {
    assistant,
    goalkeeper,
    pitchDistance,
    pitchPosition,
    goalPosition,
  }
}
